import { CalendarXIcon } from "@phosphor-icons/react";
import { goToUrl } from "apps/visits/core/utils/go-to-url";
import { useTranslation } from "react-i18next";
import { Button } from "@/core/shared/v2/ui/button";
import { IntersectionFadeIn } from "@/core/shared/v2/ui/intersection-fade-in";
import { Card, HeroLayout } from "../components";

export const LimitReached = () => {
  const { t } = useTranslation();

  return (
    <HeroLayout>
      <IntersectionFadeIn className="relative z-20 h-full">
        <div className="mx-auto flex h-full max-w-[800px] items-center justify-center px-4">
          <Card className="flex flex-col items-center text-center">
            <CalendarXIcon className="size-8 text-black" />
            <h1 className="mt-1 mb-4 font-semibold text-2xl">{t("cmsTranslations.limit_reached.title")}</h1>
            <p>{t("cmsTranslations.limit_reached.description")}</p>
            <Button variant="primary" size="lg" className="mt-6 w-full md:w-auto" onClick={() => goToUrl("/")}>
              {t("GROUP_ACTIONS_ORDERING.GENERAL.BACK_TO_HOME")}
            </Button>
          </Card>
        </div>
      </IntersectionFadeIn>
    </HeroLayout>
  );
};
